import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderTwo, BodyCopy } from 'secondstep-components'
import ContentTypeDescription from 'experienceComponents/ContentTypeDescription'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${themeGet('shutterList.backgroundColor')};
  padding-bottom: 2.5rem;
`

export const ContentSetWrapper = styled.div`
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  padding: 0 1.25rem;
  box-sizing: border-box;
  z-index: 1;
  margin-top: -1rem;
  ${themeGet('breakpoints.mobileLarge')} {
    padding: 0 1rem;
    margin-top: -0.75rem;
  }
  & div > div[data-testid='activity-type-description-shutter-desc-wrapper'] {
    padding: 1.75rem 1.75rem ${({ hasFooter }) => (hasFooter ? '0' : '1.75rem')}
      1.75rem;
    ${themeGet('breakpoints.mobileLarge')} {
      padding: 1.25rem 1.75rem
        ${({ hasFooter }) => (hasFooter ? '0' : '1.25rem')} 1.25rem;
    }
    ${HeaderTwo} {
      font-family: ${themeGet('fonts.primary')};
      font-weight: 800;
      font-size: 1.75rem;
      color: ${themeGet('colors.headers.primaryHeader')};
    }

    ${BodyCopy} {
      margin-top: 1.75rem;
      color: ${themeGet('colors.darkGray')};
      font-family: ${themeGet('fontFamily')};
    }
    div[data-testid='link-content'] {
      font-family: ${themeGet('fontFamily')};
      padding-top: 1.25rem;
      padding-bottom: unset;
    }
  }
`

export const StyledContentTypeDescription = styled(
  ContentTypeDescription,
).attrs(({ singleLink, ...props }) => ({
  id: 'shutter-desc-wrapper',
  backgroundColor: themeGet('colors.white')(props),
  borderColor: themeGet('colors.highschool.green0')(props),
  titleColor: themeGet('colors.black')(props),
  bodyColor: themeGet('colors.grayLink')(props),
  singleLink: {
    ...singleLink,
    color: themeGet('colors.themePrimary')(props),
    hoverColor: themeGet('colors.themeSecondary')(props),
  },
}))``
